import React from 'react'
import { Form } from 'antd';
import get from 'lodash/get';

import mapped_statuses from '../../data/mappedStatus';
import { withNamespaces } from 'react-i18next';

const ValidationFormStep2Component = (props) => {

    var validationExistsText;

    if (props.currentStep !== 'Step 2') {
      return null
    }
    return(
        <div className="form-group">

            <h4 className='headline-default'>{props.i18n.t('NamespaceValidateRandomizationStep2:Subject Found! Please verify details below')}:</h4>

            <h5 style={{ display: 'inline-block !important' }}>{props.i18n.t('Site ID')}: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{props.siteID}</span></h5>
            <h5 style={{  display: 'inline-block !important' }}>{props.i18n.t('User ID')}: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{props.userID}</span></h5>
            <h5 style={{  display: 'inline-block !important' }}>{props.i18n.t('Subject ID')}: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{props.subjectID}</span></h5>

            <hr />
            <p> </p>
            <h4 style={{  display: 'inline-block !important' }}>{props.i18n.t('Randomization Information')}</h4>

            <h5 style={{  display: 'inline-block !important' }}>{props.i18n.t('Randomization Date')}: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{props.randomizationDate}</span></h5>
            <h5 style={{  display: 'inline-block !important' }}>{props.i18n.t('Name')}: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{get(props, 'subject.profile.first_name')} {get(props, 'subject.profile.last_name')}</span></h5>
            <h5 style={{  display: 'inline-block !important' }}>{props.i18n.t('Email')}: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{get(props, 'subject.profile.email')}</span></h5>
            {get(props, 'subject.drug.vial_number') && <h5 style={{  display: 'inline-block !important' }}>{props.i18n.t('Drug #')}: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{get(props, 'subject.drug.vial_number')}</span></h5>}
            {get(props, 'subject.drug.drug_status') && <h5 style={{  display: 'inline-block !important' }}>{props.i18n.t('Drug Status')}: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{mapped_statuses(props.i18n)[get(props, 'subject.drug.drug_status')]}</span></h5>}
            <h5 style={{  display: 'inline-block !important' }}>{props.i18n.t('NamespaceValidateRandomizationStep2:Patient Deceased')}: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>
              {props.validationPatientDied && props.i18n.t('Yes')}
              {!props.validationPatientDied && props.i18n.t('No')}</span></h5>
            {props.validationPatientDied && <h5 style={{  display: 'inline-block !important' }}>{props.i18n.t('NamespaceValidateRandomizationStep2:Patient Deceased Date')}: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{props.validationPatientDiedDate}</span></h5>}



          {/*<h5 style={{  display: 'inline-block !important' }}>Subject Weight: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{props.randomizationWeight} kg</span></h5>


            <h5 style={{  display: 'inline-block !important' }}>Randomization Drug: <span className='bigger' style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{props.randomizationGroup === 'tpa' ? 'Alteplase tPA' : 'Tenecteplase tNK'}</span></h5>
            {props.randomizationGroup === 'tnk_tpa' ?
                <h5 style={{ marginTop: '2rem', display: 'inline-block !important' }}>Tenecteplase tNK Randomization Dose: <span className='bigger' style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{props.randomizationTNKDose}</span></h5>
                :
                <div>
                    <h5 style={{ marginTop: '2rem', display: 'inline-block !important' }}>Alteplase tPA Randomization Bolus Dose: <span className='bigger' style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{props.randomizationTPABolusDose}</span></h5>
                    <h5 style={{ marginTop: '2rem', display: 'inline-block !important' }}>Alteplase tPA Randomization Infusion Dose: <span className='bigger' style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{props.randomizationTPAInfusionDose}</span></h5>
                </div>
            }*/}

            <hr />
            <p> </p>
            <h3 style={{  display: 'inline-block !important' }}>{props.i18n.t('NamespaceValidateRandomizationStep2:Consent Information')}</h3>

            <h5 style={{  display: 'inline-block !important' }}>{props.i18n.t('Consent Exists')}: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>
                {props.consentExists === true ? <div>{props.i18n.t('Yes')}</div> : <div>{props.i18n.t('No')}</div> }
            </span></h5>


            <hr />
            <p> </p>
            <h4 style={{  display: 'inline-block !important' }}>{props.i18n.t('NamespaceValidateRandomizationStep2:Validation Information')}</h4>

            <h5 style={{  display: 'inline-block !important' }}>{props.i18n.t('NamespaceValidateRandomizationStep2:Validation Exists')}: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>
                {props.validationExists === true ? <div>{props.i18n.t('Yes')}</div> : <div>{props.i18n.t('No')}</div> }
            </span></h5>

            {
              (() => {

                if (props.validationExists) {
                    return (
                        <div className="validation-exists">
                            <h5 style={{  display: 'inline-block !important' }}>{props.i18n.t('Validation Date')}: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{props.validationExistsDate}</span></h5>
                            <h5 style={{  display: 'inline-block !important' }}>{props.i18n.t('NamespaceValidateRandomizationStep2:Has The Patient Received The Assigned Drug Package?')}: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>
                                {props.validationExistsUsedRecommendedValues === true ? <div>{props.i18n.t('Yes')}</div> : <div>{props.i18n.t('No')}</div> }
                            </span></h5>
                            <h5 style={{  display: 'inline-block !important' }}>{props.i18n.t('NamespaceValidateRandomizationStep2:Actual used drug #')}: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{props.actualUsedBottle}</span></h5>
                            <h5 style={{  display: 'inline-block !important' }}>{props.i18n.t('NamespaceValidateRandomizationStep2:Validation Comments')}: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{props.validationExistsComments}</span></h5>


                            {/* <hr />
                            <p> </p>
                            <h4 style={{  display: 'inline-block !important' }}>Vial Information</h4>

                            <h5 style={{  display: 'inline-block !important' }}>Vial Number: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{props.validationExistsVialNumber}</span></h5>
                            <h5 style={{  display: 'inline-block !important' }}>Vial Expiry Date: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{props.validationExistsVialExpiryDate}</span></h5> */}

                        </div>
                    );
                }

              })()
            }

            <hr />
            <p> </p>
            <h4 style={{  display: 'inline-block !important' }}>{props.i18n.t('NamespaceValidateRandomizationStep2:Deviation Details')}</h4>

            <h5 style={{  display: 'inline-block !important' }}>{props.i18n.t('NamespaceValidateRandomizationStep2:Has the drug been returned by the patient? Or have any other protocol deviations occurred?')}:  <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>
                {props.validationExistsDeviationOccurred === true ? <div>{props.i18n.t('Yes')}</div> : <div>{props.i18n.t('No')}</div> }
            </span></h5>
            { props.validationExistsDeviationOccurred === true ?
                <h5 style={{  display: 'inline-block !important' }}>{props.i18n.t('NamespaceValidateRandomizationStep2:Deviation Comments')}: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{props.validationDeviationExistsComments}</span></h5>
                :
                null
            }

            <h5 style={{  display: 'inline-block !important' }}>{props.i18n.t('Has the patient died?')}:  <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>
                {props.validationPatientDied === true ? <div>{props.i18n.t('Yes')}</div> : <div>{props.i18n.t('No')}</div> }
            </span></h5>
            { props.validationPatientDied === true ?
              <div>
                <h5 style={{  display: 'inline-block !important' }}>{props.i18n.t('NamespaceValidateRandomizationStep2:Patient Deceased Date')}: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{props.validationPatientDiedDate}</span></h5>
                <h5 style={{  display: 'inline-block !important' }}>{props.i18n.t('NamespaceValidateRandomizationStep2:Deviation Comments')}: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{props.validationPatientDiedComments}</span></h5>
                </div>
                :
                null
            }

            <hr />
            <p> </p>
            <h4 style={{  display: 'inline-block !important' }}>{props.i18n.t('NamespaceValidateRandomizationStep2:Validation Options')}</h4>

            <Form.Item>
                {props.getFieldDecorator('validationExistsUsedRecommendedValues', {
                    initialValue: '',
                    onChange: props.handleChange,
                    rules: [{
                        required: true,
                        message: props.i18n.t('NamespaceValidateRandomizationStep2:Has the patient  received the assigned drug bottle?')
                    }],
                })(
                  <label>
                    <h5>
                      {props.i18n.t('NamespaceValidateRandomizationStep2:Has the patient  received the assigned drug bottle?')}
                    </h5>

                    <select id="validationExistsUsedRecommendedValues" name="validationExistsUsedRecommendedValues" autoFocus size="large" className="ant-input ant-input-lg">
                      <option value="">{props.i18n.t('Please select an option')}</option>
                      <option value="true">{props.i18n.t('Yes')}</option>
                      <option value="false">{props.i18n.t('No')}</option>
                    </select>
                  </label>
                )}
            </Form.Item>

            <Form.Item>
                {props.getFieldDecorator('validationExistsDeviationOccurred', {
                    initialValue: '',
                    onChange: props.handleChange,
                    rules: [{
                        required: true,
                        message: props.i18n.t('NamespaceValidateRandomizationStep2:Has the drug been returned by the patient? Or have any other protocol deviations occurred?')
                    }],
                })(
                  <label>
                    <h5>
                     {props.i18n.t('NamespaceValidateRandomizationStep2:Has the drug been returned by the patient? Or have any other protocol deviations occurred?')}
                    </h5>

                    <select id="validationExistsDeviationOccurred" name="validationExistsDeviationOccurred" autoFocus size="large" className="ant-input ant-input-lg">
                      <option value="">{props.i18n.t('Please select an option')}</option>
                      <option value="true">{props.i18n.t('Yes')}</option>
                      <option value="false">{props.i18n.t('No')}</option>
                    </select>
                  </label>
                )}
            </Form.Item>

            <Form.Item>
                {props.getFieldDecorator('validationPatientDied', {
                    initialValue: '',
                    onChange: props.handleChange,
                    rules: [{
                        required: true,
                        message: props.i18n.t('Has the patient died?')
                    }],
                })(
                  <label>
                    <h5>
                      {props.i18n.t('Has the patient died?')}
                    </h5>

                    <select id="validationPatientDied" name="validationPatientDied" autoFocus size="large" className="ant-input ant-input-lg">
                      <option value="">{props.i18n.t('Please select an option')}</option>
                      <option value="true">{props.i18n.t('Yes')}</option>
                      <option value="false">{props.i18n.t('No')}</option>
                    </select>
                  </label>
                )}
            </Form.Item>

            <Form.Item>
              <label>
                <h5>
                  {props.i18n.t('NamespaceValidateRandomizationStep2:Overwrite existing validation data, if it exists?')}
                </h5>
                {props.getFieldDecorator('validationOverwrite', {
                    initialValue: props.validationOverwrite,
                    onChange: props.handleChange,
                    rules: [{
                        required: true,
                        message: props.i18n.t('NamespaceValidateRandomizationStep2:You need to agree to override data if you wish to proceed with this entry!')
                    }],
                })(
                  <select id="validationOverwrite" name="validationOverwrite" placeholder={props.i18n.t('NamespaceValidateRandomizationStep2:Overwrite Validation Data?')} size="large" className="ant-input ant-input-lg">
                    <option value="">{props.i18n.t('Please select an option')}</option>
                    <option value="yes">{props.i18n.t('Yes')}</option>
                    <option value="">{props.i18n.t('No')}</option>
                  </select>
                )}
              </label>
            </Form.Item>




       </div>

    );
}

export const ValidationFormStep2 = withNamespaces()(ValidationFormStep2Component)



// WEBPACK FOOTER //
// ./src/components/ValidateRandomization/ValidateRandomizationStep2.js